import { supabase } from '@/integrations/supabase/client';

export interface ClickTrackingData {
  solutionId: string;
  ipAddress?: string;
  userAgent?: string;
}

// Generate a UUID v4 session ID for enhanced tracking
const getSessionId = (): string => {
  let sessionId = sessionStorage.getItem('aizen_session_id');
  if (!sessionId) {
    // Use standard crypto.randomUUID() for UUID v4 generation
    sessionId = crypto.randomUUID();
    sessionStorage.setItem('aizen_session_id', sessionId);
  }
  return sessionId;
};

/**
 * Track a solution page view using secure edge function with enhanced visit tracking
 * Now tracks all visits (first-time and return visits) for better analytics
 */
export const trackSolutionPageView = async (solutionId: string): Promise<boolean> => {
  try {
    const sessionId = getSessionId();

    console.log(`Tracking page view for solution: ${solutionId}, session: ${sessionId.substring(0, 8)}...`);

    // Call the secure edge function using supabase.functions.invoke
    const { data, error } = await supabase.functions.invoke('track-page-view', {
      body: {
        solutionId,
        sessionId,
        userAgent: navigator.userAgent,
        referrer: document.referrer || null,
      }
    });

    if (error) {
      throw new Error(`Edge function error: ${error.message || 'Unknown error'}`);
    }

    if (!data.success) {
      throw new Error(`Tracking failed: ${data.error}`);
    }

    if (data.tracked) {
      console.log(`Successfully tracked page view for solution ${solutionId}`, {
        isFirstVisit: data.is_first_visit,
        visitNumber: data.visit_number,
        sessionId: sessionId.substring(0, 8) + '...'
      });
      return true;
    } else if (data.rateLimited) {
      // Rate limited - this is expected behavior, not an error
      console.log(`Rate limited for solution ${solutionId} - tracking skipped to prevent spam`);
      return false; // Return false but don't log as error
    } else {
      console.log(`Page view not tracked for solution ${solutionId}:`, data.error);
      return false;
    }

  } catch (error) {
    console.error('Error tracking solution page view:', error);
    // Don't throw - tracking should be non-blocking
    return false;
  }
};



